import { useContext } from "react"
import { EnderecosBloqueadosContext } from "./EnderecosBloqueadosContext"

export function useEnderecosBloqueadosContext() {
    return useContext(EnderecosBloqueadosContext)
}
